import { createFileRoute, redirect } from '@tanstack/react-router';
import WeeklyReportPage, { WeeklyReportError } from '@/modules/peer-support/weekly-report/WeeklyReportPage';
import WeeklyReportContainer from '@/modules/peer-support/weekly-report/WeeklyReportContainer';
import { pendingWeeklyReportToken, rememberWeeklyReportToken } from '@/utils/weeklyReportLink';

export const Route = createFileRoute('/peer-support/weekly-report/$token')({
  staticData: { title: 'Weekly Peer Support Activity Report' },
  preloadStaleTime: 0,
  beforeLoad: ({ params, preload }) => {
    if (preload) return;
    if (params.token !== 'resume') {
      rememberWeeklyReportToken(params.token);
      throw redirect({
        to: '/peer-support/weekly-report/$token',
        params: { token: 'resume' },
        replace: true,
      });
    }
  },
  loader: ({ preload }) => {
    if (preload) return;
    const token = pendingWeeklyReportToken();
    if (!token) throw { code: 410 };
    return { token };
  },
  component: function WeeklyReportRoute() {
    const data = Route.useLoaderData();
    return data ? <WeeklyReportPage key={data.token} token={data.token} /> : null;
  },
  errorComponent: ({ error, reset }) => (
    <WeeklyReportContainer>
      <WeeklyReportError error={error} retry={reset} />
    </WeeklyReportContainer>
  ),
});
